var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptysearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 172,
    viewBox: "0 0 182 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.213 168.301C46.3324 169.492 26.1856 173.79 11.3865 163.932C-2.49031 154.629 -3.40415 138.253 7.12192 126.174C12.5542 119.897 22.5895 128.242 17.1488 134.438C10.295 142.309 12.9688 151.289 22.4118 155.506C27.8441 157.969 34.1986 157.574 40.0455 157.252C47.4832 156.778 54.9208 156.214 62.3584 155.659C70.8199 155.104 71.7422 167.666 63.213 168.301Z",
    fill: "url(#paint0_linear_438_1153)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.095 78.1555C130.084 61.0631 129.915 50.489 126.572 34.3542L120.802 9.31104L106.925 15.9098C103.752 15.1131 100.24 14.9522 96.3902 15.6684C94.3849 15.9903 90.0357 17.5756 90.0357 17.5756L76.4127 14.236C76.4127 14.236 78.3335 27.8278 78.8327 38.402C79.6704 56.6854 75.0673 70.3577 70.3881 82.6781C63.4497 101.122 46.8145 116.308 44.2253 129.344C41.213 144.529 48.9045 165.831 64.5328 169.251C72.7235 171.077 94.2072 169.886 106.662 168.929C120.539 167.818 128.815 166.7 137.919 165.75C146.448 164.793 159.648 147.628 150.704 122.906C146.719 112.018 139.197 100.012 134.095 78.1555Z",
    fill: "url(#paint1_linear_438_1153)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.161 76.1439L156.518 53.0884C157.085 50.7386 159.623 49.2901 162.052 49.9017C164.522 50.4409 166.045 52.855 165.402 55.1646L161.925 78.3568C160.952 84.9958 157.762 91.144 152.693 95.7792C146.262 101.694 135.889 106.152 120.658 98.6279L133.748 77.2705C133.748 77.2705 134.552 78.1718 135.948 79.0409C139.595 81.3343 144.519 79.9261 146.161 76.1439Z",
    fill: "#FFD590"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.258 49.6924C104.59 49.6924 104.006 49.2176 103.921 48.5819L103.168 43.0936C103.084 42.3774 103.583 41.7417 104.336 41.6612C105.089 41.5807 105.757 42.0555 105.842 42.7717L106.595 48.26C106.68 48.9762 106.172 49.6119 105.427 49.6924C105.427 49.6924 105.343 49.6924 105.258 49.6924Z",
    fill: "#33312D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9946 40.5508C99.8253 39.0379 101.915 38.5631 103.845 38.4022C105.765 38.2412 107.771 38.0803 107.94 39.5932C108.109 41.1061 106.349 43.7295 104.344 43.8824C102.415 43.9709 100.155 42.0637 99.9946 40.5508Z",
    fill: "#33312D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5368 171.762C98.6407 171.207 101.044 169.38 100.942 163.658L101.974 116.517C101.391 112.614 89.24 109.146 85.1277 109.701L85.5254 111.351C81.4216 111.906 73.5016 115.809 74.0855 119.712L86.0161 165.67C86.6 169.573 90.433 172.317 94.5368 171.762Z",
    fill: "#FFD590"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.701 6.85685C115.581 7.64548 107.644 14.8639 105.943 23.9412C105.816 25.1564 105.799 26.4037 105.909 27.6671C106.899 39.1265 117.476 47.6486 129.525 46.707C131.818 46.53 134.001 46.015 136.024 45.2263C137.708 34.3222 135.981 15.6928 132.123 7.25116C130.075 6.82466 127.909 6.67981 125.701 6.85685Z",
    fill: "#FFD590"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.545 32.4766C122.382 32.3369 124.546 29.7193 124.378 26.6301C124.21 23.5408 121.773 21.1497 118.936 21.2894C116.098 21.4291 113.934 24.0467 114.102 27.136C114.271 30.2252 116.707 32.6163 119.545 32.4766Z",
    fill: "#120B09"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7042 37.2672C94.2864 37.1893 95.493 35.73 95.3992 34.0078C95.3055 32.2857 93.9469 30.9527 92.3647 31.0306C90.7825 31.1085 89.5759 32.5677 89.6697 34.2899C89.7634 36.0121 91.122 37.3451 92.7042 37.2672Z",
    fill: "#120B09"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M181.411 64.5153L179.042 67.3882C178.391 68.1848 177.181 68.3216 176.343 67.694L146.491 45.411L151.238 39.6653L181.09 61.9482C181.919 62.5759 182.063 63.7186 181.411 64.5153Z",
    fill: "url(#paint2_linear_438_1153)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M106.172 10.6711C96.5259 22.3558 98.6667 39.2631 110.953 48.429C123.239 57.6029 141.016 55.5669 150.654 43.8823C160.3 32.1976 158.159 15.2903 145.873 6.12443C133.587 -3.04947 115.81 -1.01351 106.172 10.6711ZM144.409 39.2149C137.479 47.6162 124.694 49.0808 115.86 42.4901C107.027 35.8994 105.487 23.7399 112.417 15.3386C119.347 6.93721 132.132 5.47261 140.966 12.0633C149.799 18.6541 151.339 30.8135 144.409 39.2149Z",
    fill: "#72ACF1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_438_1153",
    x1: 6.70232,
    y1: 147.099,
    x2: 75.8746,
    y2: 147.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28D29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_438_1153",
    x1: 98.5297,
    y1: 123.87,
    x2: 99.5271,
    y2: 242.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28D29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_438_1153",
    x1: 154.51,
    y1: 32.2346,
    x2: 169.108,
    y2: 69.0222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000351356,
    stopColor: "#2970B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4722,
    stopColor: "#72ACF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptysearch);
export default __webpack_public_path__ + "static/media/emptysearch.11d2ed50fd3433c6d5eeb0529398c6ea.svg";
export { ForwardRef as ReactComponent };